/**
 *
 * Asynchronously loads the component for ReserveUsernameForm
 *
 */

import { lazyLoad } from 'utils/loadable';

export const IceBreakerShare = lazyLoad(
  () => import('./index'),
  module => module.IceBreakerShare,
);
